import $ from 'jquery';

function decrementField(id) {
    const $el = $(id)
    if (!$el) {
        return
    }
    const min = parseInt($el.attr('min'))
    const value = parseInt($el.val())

    if (value <= min) {
        $el.val(min)
        return
    }
    $el.val(value - 1)
    $el.trigger('change')
}

function incrementField(id) {
    const $el = $(id)
    if (!$el) {
        return
    }
    const max = parseInt($el.attr('max'))
    const value = parseInt($el.val())

    if (value >= max) {
        $el.val(max)
        return
    }

    $el.val(value + 1)
    $el.trigger('change')
}

function toggleDisableButton(id, decrement, increment) {
    const min = $(id).attr('min')
    const max = $(id).attr('max')
    const val = parseInt($(id).val())

    if (val <= min) {
        decrement.prop('disabled', true)
        return
    }
    if (val >= max) {
        increment.prop('disabled', true)
        return
    }
    decrement.prop('disabled', false)
    increment.prop('disabled', false)
}

function initNumberControlField() {
    const $this = $(this)

    $this.find('button[aria-controls]').each(function() {
        const id = `#${this.getAttribute('aria-controls')}`;
        const operation = this.getAttribute('data-operation');

        const operations = {
            increment: () => incrementField(id),
            decrement: () => decrementField(id)
        }

        const decrement = $(id).parent().prev()
        const increment = $(id).parent().next()

        toggleDisableButton(id, decrement, increment);

        $(id).on('change', function() {
            toggleDisableButton(id, decrement, increment)
        })

        $(this).on('click', function() {
            operations[operation]()
        })

    })
}

$('.c-number-control-field').each(initNumberControlField);
